<template>
  <tk-container
    class=""
  >
    <!-- 个人信息 -->
    <tk-flex
      between
      middle
      :gutter="20"
      class="mt-8 px-15 pt-15 pb-10"
      slot="header"
    >
      <tk-flex
        middle
        :gutter="20"
        style="width: calc(100% - 50px)"
        class="flex-grow cursor-pointer"
        @click.native="$push('/account/info')"
        v-if="$store.state.user"
      >
        <div
          class="circle-58 overflow-hidden"
        >
          <img
            :src="$store.state.user.avatar|| '/img/avatar.png'"
            class="circle-58 overflow-hidden"
          >
        </div>
        <div
          style="width: calc(100%-78px)"
          class="flex flex-grow flex-col line-height-22"
        >
          <div class="flex-grow text-18 font-bold line-1">
            {{ $store.state.user.nickName || $store.state.user.phone }}
          </div>
          <div class="mt-2 text-13 text-gray">
            欢迎来到红商学院～
          </div>
        </div>
      </tk-flex>
      <div flex flex-col>
        <global-back />
        <div
          class="square-30 mt-5 flex-center cursor-pointer rounded-8 bg-white"
          @click="onHome"
        >
          <van-icon name="wap-home-o" />
        </div>
      </div>
    </tk-flex>
    <div class="p-x-15 pb-15">
      <div class="h-10" />
      <!-- 我的课程 -->
      <div
        class="mt-2 rounded-12 bg-white p-15 shadow"
      >
        <div
          class="flex cursor-pointer items-center justify-between"
          @click="$push({
            path: '/common/record',
            query: {
              type: 'course',
            },
          })"
        >
          <div class="text-14 font-bold">
            我的课程
          </div>
          <van-icon name="arrow" />
        </div>
        <van-row
          v-if="list.length > 0"
          class="mt-10"
          :gutter="10"
        >
          <van-col
            v-for="(item, index) in list"
            :key="index"
            span="6"
            @click="$push({
              path: '/course/courseDetail',
              query: {
                id: item.course ? item.course.objectId : '&&&&&',
              },
            })"
          >
            <div class="overflow-hidden rounded-8">
              <van-image
                width="100%"
                height="auto"
                lazy-load
                fit="cover"
                :src="item.course ? item.course.coverPicture : ''"
              />
              <div class="mt-2 text-10 line-height-14 line-2">
                {{ item.course ? item.course.title : '该课程不存在/已被作者删除' }}
              </div>
            </div>
          </van-col>
        </van-row>
        <div v-else>
          <global-empty
            :top="10"
            :is-small="true"
            word="没有找到相关内容～"
          />
        </div>
      </div>
      <!-- 功能列表 -->
      <tk-flex
        column
        class="mt-15 rounded-12 bg-white px-15 pb-22 shadow"
      >
        <div
          v-for="(item, index) in actions"
          :key="index"
          class="flex cursor-pointer items-center justify-between w-full mt-22"
          @click="$push(item.path)"
        >
          <div class="text-14 font-bold line-height-22">
            {{ item.label }}
          </div>
          <van-icon name="arrow" color="#9C9C9C" />
        </div>
        <div class="h-1 bg-gray-F1F4F8 w-full my-18" />
        <div
          class="mx-auto cursor-pointer text-14 font-600 text-red"
          @click="logout"
        >
          退出登录
        </div>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
import { mapState } from 'vuex'
import { Toast, Dialog } from 'vant'
export default {
  name: 'account-mine',
  data () {
    return {
      list: [],
      actions: [
        {
          label: '兑换中心',
          path: '/exchange/exchange',
        },
        {
          label: '个人信息',
          path: '/account/info',
        },
        {
          label: '协议和政策',
          path: '/article/protocol',
        },
      ],
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
  },
  methods: {
    // | 返回首页
    onHome () {
      this.$cleanHistory()
      this.$replace('/')
    },
    // | 获取我的课程
    async init () {
      const result = await this.$tkParse.getList('/classes/exchangeRecord', {
        params: {
          order: '-updatedAt',
          limit: 4,
          include: 'course',
          where: {
            exchangeUser: this.user.objectId,
            status: '已使用',
          },
        },
      }).catch((e) => {
        this.$tkGlobal.toast.add('查询课程失败')
        throw e
      })
      this.list = result
    },
    // | 退出登录
    logout () {
      Dialog.confirm({
        title: '提示',
        message: '确定退出登录吗？',
        confirmButtonColor: '#F8604E',
      }).then(() => {
        this.$store.commit('setSessionToken', null)
        this.$store.commit('setUser', null)
        this.$tkParse.setSessionToken('')
        Toast.success('退出成功')
        this.$cleanHistory()
        if (this.$store.state.user || this.$store.state.sessionToken) {
          this.$cleanHistory()
        }
        this.$cloudAjax.config.headers = null
        this.$replace('/')
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .van-icon-wap-home-o {
    font-weight: bold !important;
    color: #272636 !important;
  }
}

</style>
